import React, { useState } from 'react';
import InputTextField from '../../Views/inputtextfield/InputTextField';
import Button from '../../Views/buttons/Button';
import endPoints from '../../API/endPoints';
import beApi from '../../API/beApi';
import { useSelector } from 'react-redux';
import { RootState } from '../../Redux/store';
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { toast } from 'react-toastify';
import { validateEmail, validateMobile, validateFullName } from '../../UtilityFunctions';
import axios from 'axios';

export interface IEditPartnerSliderContent {
    onClose: () => void;
    hotelId: number;
    refreshData: () => void;
}

const AddCancellationPolicy: React.FC<IEditPartnerSliderContent> = ({ onClose, hotelId, refreshData }) => {
    const { auth_token } = useSelector((state: RootState) => state.auth);

    const { addCancelPolicy } = endPoints.CANCELATIONPOLICY;

    // initial States
    const [PolicyName, setPolicyName] = useState("");
    const [PolicyDescription, setPolicyDescription] = useState("");
    

    // initial helper text
    const [salesExecutivHelperText, setSalesExecutivHelperText] = useState("");
    
  
    const [saveLoader, setSaveLoader] = useState<boolean>(false);

    const salesExecutiveNameOnChange = (name: string) => {
        if (!validateFullName(name) && name) {
            setSalesExecutivHelperText("Please enter a valid name");
        } else {
            setSalesExecutivHelperText("");
        }
        setPolicyName(name);
    }

   




    const addSalesExecutiveDetails = async () => {
        setSaveLoader(true);
        if (PolicyName.length, PolicyDescription.length) {
            try {
                const payload = {
                    hotel_id: hotelId,
                    policy_name: PolicyName,
                    cancel_policy: PolicyDescription,
                    
                }
                let response = await beApi.post(`${addCancelPolicy}`, payload,
                    {
                        headers: {
                            Authorization: `Bearer ${auth_token}`,
                        }
                    })
                if (response.data.status === 1) {
                    setSaveLoader(false);
                    toast(response.data.message, {
                        hideProgressBar: true,
                        type: "success",
                    });
                    onClose();
                    refreshData();
                }
            } catch (error) {
                console.log(error);
                setSaveLoader(false);
            }
        } else {
            toast.error("Kindly fill all the fields");
        }
        setSaveLoader(false);
    }


    return (
        <>
            <div className="side__slider__header__label__wrapper">
                <div className="side__slider__close">
                    <i
                        onClick={() => {
                            onClose();
                        }}
                        className="bi bi-x"
                    ></i>
                </div>
                <div className="standard-page--label">Add Cancellation Policy</div>
            </div>

            <div className="height-64px"></div>

            <div className="add__new__sales__executive mt-3">
                <div className="div__inputs__wrapp">
                    <div className="div--email--input">
                        <InputTextField
                            value={PolicyName || ""}
                            helperText={salesExecutivHelperText}
                            label="Policy Name"
                            handleChange={(e) => salesExecutiveNameOnChange(e.target.value)}
                            handleFocus={(e) => {
                                if (!e.target.value) setSalesExecutivHelperText("");
                            }}
                        />
                    </div>
                </div>

             

                
            </div>
            <>
            <p style={{color:"#414141",fontWeight:"semibold",marginTop:"15px"}}>Policy Description</p>
                     <div className="cancelation__policy__wrapper">
                        <div className="manage__terms__poliy__wrapper pb-0">
                            <div id="editor">
                                <CKEditor
                                    editor={ClassicEditor}
                                    // data={cancelationData}
                                    config={{
                                        removePlugins: [
                                            "EasyImage",
                                            "ImageUpload",
                                            "MediaEmbed",
                                            "Table",
                                        ],
                                    }}
                                    onChange={(event: string, editor: any) => {
                                        const data = editor.getData();
                                        setPolicyDescription(data);
                                        // setCharCount({
                                        //     ...charCount,
                                        //     terms_cond: removeTags(data).length,
                                        // });
                                    }}
                                />
                            </div>
                        </div>
                        <div className="character__count__number">
                            {/* <div className="character__count__label">
                                Used <span className='count_number'>{charCount.terms_cond}</span>
                            </div> */}
                        </div>

                        
                     
                    </div>

                </>
           

            <div className="side__slider__panel__btn">
                <div className="__btn__wrapper justify-content-between w-100">
                    <Button className="primary-btn" handleClick={addSalesExecutiveDetails} loader={saveLoader}>Save</Button>
                </div>
            </div>
        </>
    )
}

export default AddCancellationPolicy